(() => {
 if (window.heirvaleCouponUnlock) { window.heirvaleCouponUnlock(); return; }
 const sessionKey = 'heirvale-offer-session-start-v1';
 let started = Date.now();
 try {
  const saved = Number(sessionStorage.getItem(sessionKey));
  if (Number.isFinite(saved) && saved > 0 && saved <= started) started = saved;
  else sessionStorage.setItem(sessionKey, String(started));
 } catch (_) {}
 function tick() {
  const seconds = Math.max(0, Math.ceil((started + 37 * 60 * 1000 - Date.now()) / 1000));
  document.querySelectorAll('[data-hv-timer]').forEach(el => {
   el.hidden = seconds === 0;
   el.textContent = seconds > 0 ? String(Math.floor(seconds / 60)).padStart(2,'0') + ':' + String(seconds % 60).padStart(2,'0') : '';
  });
 }
 tick();
 const clock = setInterval(() => { tick(); if (Date.now() >= started + 37 * 60 * 1000) clearInterval(clock); }, 1000);
 let timer, pending = false, again = false;
 function paint(count) {
  document.querySelectorAll('[data-hv-coupons]').forEach(el => {
   const goal = count < 2 ? 2 : count < 3 ? 3 : 4;
   const discount = goal === 2 ? 15 : goal === 3 ? 20 : 30;
   const remaining = goal - count;
   const message = count === 0 ? el.dataset.empty : count >= 4 ? el.dataset.complete : (remaining === 1 ? el.dataset.one : el.dataset.many).replace('[count]',remaining).replace('[discount]',discount);
   const text = el.querySelector('.hv-coupons__message');
   if (text.textContent !== message) text.textContent = message;
   tick();
  });
 }
 async function refresh() {
  if (pending) { again = true; return; }
  pending = true;
  try {
   const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin',cache:'no-store'});
   if (res.ok) paint((await res.json()).item_count);
  } catch (_) {} finally { pending = false; if (again) { again = false; schedule(); } }
 }
 function schedule() { clearTimeout(timer); timer = setTimeout(refresh,150); }
 window.heirvaleCouponUnlock = schedule;
 const initial = document.querySelector('[data-hv-coupons]');
 if (initial) paint(Number(initial.dataset.count) || 0);
 schedule();
 const cartSelector = 'cart-drawer,cart-items,#cart-icon-bubble';
 new MutationObserver(records => {
  if (records.some(record => {
   const node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
   return node?.closest(cartSelector) || [...record.addedNodes].some(n => n.nodeType === 1 && (n.matches(cartSelector) || n.querySelector(cartSelector)));
  })) schedule();
 }).observe(document.body,{subtree:true,childList:true,characterData:true});
 ['cart:updated','cart:change','cart:refresh','shopify:section:load'].forEach(name => document.addEventListener(name,schedule));
 document.addEventListener('submit',event => {
  if (event.target.matches('form[action*="/cart/add"]')) [600,1600,3000].forEach(ms => setTimeout(schedule,ms));
 });
 window.addEventListener('pageshow',schedule);
 document.addEventListener('visibilitychange',() => { if (!document.hidden) schedule(); });
})();